import React from 'react';
import TechnicalDataTable from '../TechnicalDataTable';
import { getTableData } from './utils';

export default function OvenTechnicalSpecPage({ ovenSpec }) {
  if (!ovenSpec) return null;

  return (
    <div className="a4-paddings quotation-page quotation-machines-details-page">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-section-block">
          <TechnicalDataTable data={getTableData(ovenSpec)} title={ovenSpec?.label || 'Technical Specification'} />
        </div>
      </div>
    </div>
  );
}
